import apiClient from './apiClient';
import { API_CONFIG } from '../config';

function normalizePanditProfile(profile = {}) {
  const services = Array.isArray(profile.services) ? profile.services : [];
  const specialties = services
    .map((item) => item?.name || item?.title || item?.serviceName)
    .filter(Boolean);

  return {
    id: profile.id || String(profile.userId || ''),
    userId: Number(profile.userId || 0) || null,
    name: profile.name || 'Unknown Pandit',
    location: profile.city || 'Location not set',
    city: profile.city || '',
    rating: Number(profile.rating || 0) || 0,
    experienceYears: Number(profile.experienceYears || 0) || 0,
    languages: ['Hindi'],
    specialties
  };
}

function normalizeCategoryCard(card = {}) {
  const serviceCount = Number(card.serviceCount || 0);
  return {
    id: card.id || card.slug || '',
    title: card.title || 'Category',
    icon: card.icon || '🕉️',
    color: card.color || 'from-orange-500 to-amber-600',
    description: card.description || '',
    serviceCount
  };
}

function normalizeCategoryService(item = {}) {
  return {
    id: item.code || '',
    code: item.code || '',
    name: item.name || '',
    title: item.name || '',
    description: item.shortDescription || '',
    featured: Boolean(item.featured)
  };
}

class CatalogService {
  async getPandits() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.CATALOG.PANDITS);
    const data = Array.isArray(response.data) ? response.data : [];
    return data.map(normalizePanditProfile);
  }

  async getPanditByUserId(userId) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.CATALOG.PANDIT_BY_USER(userId));
    return normalizePanditProfile(response.data || {});
  }

  async upsertPanditProfile(userId, payload) {
    const response = await apiClient.put(API_CONFIG.ENDPOINTS.CATALOG.PANDIT_BY_USER(userId), payload);
    return normalizePanditProfile(response.data || {});
  }

  async getServiceCategoryCards() {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.CATALOG.CATEGORY_CARDS);
    const data = Array.isArray(response.data) ? response.data : [];
    return data.map(normalizeCategoryCard);
  }

  async getCategoryServices(categoryId) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.CATALOG.CATEGORY_SERVICES(categoryId));
    const items = Array.isArray(response.data?.services) ? response.data.services : [];
    return items.map(normalizeCategoryService);
  }
}

const catalogService = new CatalogService();

export default catalogService;
